import * as Headless from '@headlessui/react'
import clsx from 'clsx'
import React, { forwardRef } from 'react'

export const Select = forwardRef(function Select({ className, multiple, ...props }, ref) {
  return (
    <span className={clsx('relative block w-full', className)}>
      <Headless.Select
        ref={ref}
        multiple={multiple}
        {...props}
        className={clsx(
          'block w-full appearance-none rounded-lg border border-zinc-300 bg-white py-2 text-sm/6 text-zinc-950 shadow-sm transition',
          multiple ? 'px-3' : 'pl-3 pr-9',
          'hover:border-zinc-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:bg-zinc-50 disabled:text-zinc-500'
        )}
      />
      {!multiple && (
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-zinc-400">
          <svg className="h-4 w-4" viewBox="0 0 16 16" aria-hidden="true" fill="none">
            <path d="M5.75 10.25 8 12.5l2.25-2.25M10.25 5.75 8 3.5 5.75 5.75" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      )}
    </span>
  )
})
